import ThemeRoutes from "containers/admin/clients/client/theme-page/theme-page-routes";
import ThemePageHeader from "containers/admin/clients/client/theme-page/components/theme-page-header/theme-page-header";

import {
  ThemePreviewProvider,
  useThemePreviewContext,
} from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

const ThemePage = () => {
  return (
    <ThemePreviewProvider>
      <ThemePageContent />
    </ThemePreviewProvider>
  );
};

const ThemePageContent = () => {
  const { themeError } = useThemePreviewContext();

  return (
    <>
      <div className="pl-3 pr-5 pt-3 pb-5">
        <ThemePageHeader />
      </div>

      {!themeError ? <ThemeRoutes /> : <span className="p-8">{themeError}</span>}
    </>
  );
};

export default ThemePage;
